module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/flash-black-phone-content.996f3c3a.png";